/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Cell } from "react-table";
import styled from "styled-components";
import { FlexContainer } from "~/components";
import { ContactDelete } from "~/components/Contacts/ContactDelete";
import { ContactEdit } from "~/components/Contacts/ContactEdit";
import { ExternalRole, Contact } from "~/models";

const RoleWrapper = styled.span`
  width: 100%;
  display: flex;
  align-items: flex-start;
  font-size: 0.8rem;
  line-height: 1.4;
`;

export const ContactsListColumns = (
  fetchContacts: () => void,
  canEdit: boolean
) => [
  {
    Header: "Name",
    accessor: "name",
    disableSortBy: true,
    width: "35%",
  },
  {
    Header: "Contact Type",
    accessor: "externalRoles",
    disableSortBy: true,
    width: "35%",
    Cell: ({ row }: Cell<Contact>) => {
      const roles = row?.original?.externalRoles;

      return (
        <FlexContainer justify="center" direction="column" align="center">
          {roles?.map((r: ExternalRole) => (
            <RoleWrapper key={r.id}>{r?.name}</RoleWrapper>
          ))}
        </FlexContainer>
      );
    },
  },
  {
    Header: "Position",
    accessor: "position",
    disableSortBy: true,
  },
  {
    Header: "Email and phone",
    accessor: "email",
    disableSortBy: true,
    Cell: ({ row }: Cell<Contact>) => (
      <>
        <div>{row.original.email}</div>
        {row.original.phoneNumber && <div>{row.original.phoneNumber}</div>}
      </>
    ),
  },
  {
    Header: () => <div style={{ textAlign: "right" }}>Actions</div>,
    accessor: "actions",
    disableSortBy: true,
    Cell: ({ row }: Cell<Contact>) => {
      return (
        <>
          {canEdit && (
            <FlexContainer>
              <ContactEdit
                refetch={fetchContacts}
                contactId={row?.original?.id || ""}
              />
              <ContactDelete
                deleteCallback={fetchContacts}
                initialValues={row?.original}
              />
            </FlexContainer>
          )}
        </>
      );
    },
  },
];
